import { bl_fi_mst_item_hdr_RowClass, bl_fi_mst_pricing_scheme_link_RowInterface } from "../../../dbschema";
import { BaseContainerModel } from "../../base-container.model";

export class ItemHdrWithMtoChildPricingContainer extends BaseContainerModel {
  bl_fi_mst_item_hdr: bl_fi_mst_item_hdr_RowClass = new bl_fi_mst_item_hdr_RowClass();
  bl_fi_mst_pricing_scheme_links: bl_fi_mst_pricing_scheme_link_RowInterface[] = [];
  bl_fi_mst_pricing_scheme_2_links: bl_fi_mst_pricing_scheme_link_RowInterface[] = [];
}